var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAdmin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3a3.75 3.75 0 110 7.5A3.75 3.75 0 019 3zm0-1.5A5.25 5.25 0 109 12 5.25 5.25 0 009 1.5zM16.5 22.5H15v-3.75A3.75 3.75 0 0011.25 15h-4.5A3.75 3.75 0 003 18.75v3.75H1.5v-3.75a5.25 5.25 0 015.25-5.25h4.5a5.25 5.25 0 015.25 5.25v3.75zM18.75 12.135l-1.942-1.942-1.058 1.057 3 3L24 9l-1.058-1.058-4.192 4.193z",
    fill: "#45464F"
  })));
}
export default SvgUserAdmin;